import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
import RightSlider from 'component/hoc/rightSlider/RightSlider';
import DataAiForm from 'component/organism/workflow/forms/data-ai/DataAiForm';
import { FormikProvider, useFormik } from 'formik';
import { isEqual } from 'lodash';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import * as Yup from 'yup';

const DataAiModal = ({
  knowledgeBaseData,
  isOpen,
  onClose,
  title,
  id,
  isLoading,
  isError,
}) => {
  const {
    workflowData,
    setWorkflowData,
    selectedNode,
    initialWorkflowData,
    setIsChanged,
  } = useWorkflowContext();

  const [init, setInit] = useState({});

  useEffect(() => {
    setInit({
      agentType: selectedNode?.dataAI?.agentType || undefined,
      agentId: selectedNode?.dataAI?.agentId || undefined,
      question:
        selectedNode?.dataAI?.question === '' ||
        selectedNode?.dataAI?.question === undefined
          ? '<p>{last_user_input}</p>'
          : selectedNode?.dataAI?.question,
      promptDescription: selectedNode?.dataAI?.promptDescription || '',
      responseThemeId: selectedNode?.dataAI?.responseThemeId || '',
      outputVariableId: selectedNode?.dataAI?.outputVariableId || '',
      endpoints: selectedNode?.dataAI?.endpoints?.length
        ? selectedNode.dataAI.endpoints.map((m) => m.agentConnectionId)
        : [],
    });
  }, [selectedNode]);

  const formik = useFormik({
    initialValues: init,
    enableReinitialize: true,
    validationSchema: Yup.object({
      question: Yup.string().required('Question is required'),
      promptDescription: Yup.string(),
      responseThemeId: Yup.string().required('Response Theme is required'),
      outputVariableId: Yup.string().required('Variable is required'),
      endpoints: Yup.array().min(1, 'At least one endpoint is required'),
    }),
    onSubmit: (values) => {
      const initialNode = initialWorkflowData?.find((node) => node?.id === id);
      if (initialNode) {
        const {
          promptDescription,
          responseThemeId,
          question,
          outputVariableId,
          endpoints,
        } = initialNode?.dataAI || {};
        const initialMessageObject = {
          question:
            question === '' || question === undefined
              ? '<p>{last_user_input}</p>'
              : question,
          promptDescription,
          responseThemeId,
          outputVariableId,
          endpoints: endpoints?.length
            ? endpoints?.map((m) => m.agentConnectionId)
            : ['all'],
        };
        const changed = !isEqual(values, initialMessageObject);
        setIsChanged((prev) => {
          const alreadyExists = prev?.includes(id);
          if (changed && !alreadyExists) {
            return [...prev, id];
          }
          if (!changed && alreadyExists) {
            return prev?.filter((nodeId) => nodeId !== id);
          }
          return prev;
        });
      }
    },
  });

  const handleSubmit = async () => {
    await formik.handleSubmit();
    try {
      setTimeout(() => {
        const validateEndpoint = formik.values.endpoints
          .map((endpointId) => {
            return { agentConnectionId: endpointId };
          })
          .filter(Boolean);

        const updatedValues = {
          ...formik.values,
          endpoints: validateEndpoint,
        };

        formik.setSubmitting(false);

        const updatedNodes = workflowData?.nodes?.map((node) =>
          node.id === id
            ? { ...node, dataAI: updatedValues, is_Error: isError }
            : node
        );

        setWorkflowData((prev) => ({
          ...prev,
          nodes: updatedNodes,
        }));

        onClose();
        formik.resetForm();
      }, [100]);
    } catch {
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    const updatedNodes = workflowData?.nodes?.map((node) =>
      node.id === id ? { ...node, is_Error: isError } : node
    );
    setWorkflowData((prev) => ({
      ...prev,
      nodes: updatedNodes,
    }));
  }, [isError]);

  useEffect(() => {
    if (isError) {
      formik.handleSubmit();
    }
  }, [isOpen]);

  return (
    <RightSlider
      title={title}
      action={{
        isOpen: isOpen,
        setIsOpen: handleSubmit,
      }}
    >
      <FormikProvider value={formik}>
        <DataAiForm isLoading={isLoading} workflowData={workflowData} />
      </FormikProvider>
    </RightSlider>
  );
};

export default DataAiModal;
